import 'reflect-metadata';

import { inject, injectable } from 'inversify';
import React from 'react';

import { UserPrincipalComponentFactory } from '../infrastructure/factories/UserPrincipal.component.factory';
import { TLogoutCard } from '../infrastructure/ui/LogoutCard/LogoutCard.view';

@injectable()
export class UserPrincipalUIService {
  constructor(
    @inject(UserPrincipalComponentFactory)
    private readonly userPrincipalComponentFactory: UserPrincipalComponentFactory,
  ) {}

  public createLogoutCardComponent(
    payload: TLogoutCard,
  ): React.ReactElement<TLogoutCard> {
    return this.userPrincipalComponentFactory.createLogoutCardComponent(
      payload,
    );
  }
}
